import { useEffect, useState } from 'react';

import { getPartialTask } from 'services/dashboard.service';

/** RDN-25: rascunho parcial do cadastro, lido só quando o topo chama para cadastrar; `reload:partialTask` relê. */
export function useRascunho(ativo: boolean): boolean {
  const [temRascunho, setTemRascunho] = useState(false);

  useEffect(() => {
    if (!ativo) {
      setTemRascunho(false);
      return;
    }
    let ativa = true;

    function ler() {
      getPartialTask().then(rascunho => {
        if (ativa) setTemRascunho(!!rascunho?.team);
      });
    }

    ler();
    document.addEventListener('reload:partialTask', ler, false);
    return () => {
      ativa = false;
      document.removeEventListener('reload:partialTask', ler);
    };
  }, [ativo]);

  return temRascunho;
}
